"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PicnicBench;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function PicnicBench(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "picnic-bench"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-2",
    "data-name": "outline",
    d: "M83,67a2.5,2.5,0,0,1-4.32,2.53L69,52.94H31L21.31,69.55A2.5,2.5,0,0,1,17,67L33.48,38.9a2.5,2.5,0,1,1,4.31,2.53L34,47.94H66l-3.81-6.51a2.5,2.5,0,1,1,4.31-2.53ZM23,50.32a1.5,1.5,0,0,0-1.5-1.5H10a1.5,1.5,0,0,0,0,3H21.45A1.5,1.5,0,0,0,23,50.32ZM90,48.82H78.55a1.5,1.5,0,0,0,0,3H90a1.5,1.5,0,0,0,0-3ZM15.76,34.22H27.5a2.5,2.5,0,0,0,0-5H15.76a2.5,2.5,0,1,0,0,5Zm18.88,0H46.42a2.5,2.5,0,0,0,0-5H34.64a2.5,2.5,0,0,0,0,5Zm18.88,0H65.33a2.5,2.5,0,0,0,0-5H53.52a2.5,2.5,0,0,0,0,5Zm18.88,0H84.24a2.5,2.5,0,0,0,0-5H72.4a2.5,2.5,0,0,0,0,5Z"
  }))));
}